import { useEffect, useState } from 'react';

// Lists of SEO Hub documents served by our own server (published, live only).
const cache = new Map();

const fetchList = (url) => {
  if (!cache.has(url)) {
    const request = fetch(url)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`Request failed (${res.status})`))))
      .then((data) => ({ items: data.items || [], total: data.total || 0 }));
    request.catch(() => cache.delete(url));
    cache.set(url, request);
  }
  return cache.get(url);
};

const useHubList = (url) => {
  const [state, setState] = useState({ items: [], total: 0, loading: true, error: null });
  useEffect(() => {
    let cancelled = false;
    fetchList(url)
      .then((data) => !cancelled && setState({ ...data, loading: false, error: null }))
      .catch((error) => !cancelled && setState({ items: [], total: 0, loading: false, error }));
    return () => {
      cancelled = true;
    };
  }, [url]);
  return state;
};

export const useBlogPosts = (limit = 200) => useHubList(`/api/blog?limit=${limit}`);

export const usePillarPages = (limit = 8) => useHubList(`/api/documents?pillar=1&limit=${limit}`);
